import React from "react"
import { NavLink } from "react-router-dom"
import styles from "../../styles/NavMain.module.css"

export default function MenuSysAdmin() {
  return (
    <ul>
      <li>
        <NavLink to="/" end className={({ isActive }) => isActive ? styles.active : ""}>Workbench</NavLink>
      </li>
      <li>
        <NavLink to="/data-order/list" className={({ isActive }) => isActive ? styles.active : ""}>Data Orders</NavLink>
      </li>
      <li>
        <NavLink to="/carrier-directory/list" className={({ isActive }) => isActive ? styles.active : ""}>Carrier Directory</NavLink>
      </li>
      <li>
        <NavLink to="/hospital-directory/list" className={({ isActive }) => isActive ? styles.active : ""}>Hospital Directory</NavLink>
      </li>
      <li>
        <NavLink to="/index-file/list" className={({ isActive }) => isActive ? styles.active : ""}>Index Management</NavLink>
      </li>
      <li>
        <NavLink to="/organization/list" className={({ isActive }) => isActive ? styles.active : ""}>Manage Organizations</NavLink>
      </li>
      <li>
        <NavLink to="/user/list" className={({ isActive }) => isActive ? styles.active : ""}>Manage Users</NavLink>
      </li>
    </ul>
  )
}
